import GaugeWithNeedle from '../../../../../../../components/Charts/GaugeNeedle/GaugeWithNeedle'



export default function GetHeartGauge() {

  return (

      <GaugeWithNeedle realAge={49} chronologicalAge={62} />
    
  );
};




